import { observer } from 'mobx-react-lite';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { checkLogin, redirectToLogin } from '@/utils/auth';
import { useStore } from './store';
import { Loading } from '@arco-design/mobile-react';
import { useOrg } from '@/utils/hooks/useOrg';
import { useVisualTrackingLayoutInit } from '@/utils/business/visualTracking/useVisualTrackingLayoutInit';
import {
  isCurrentWindowFramed,
  resolveVisualTrackingPreviewMode,
} from '@/utils/business/visualTracking/previewMode';
import { TrackingClientType } from '@/constants/business/tracking';

const MobileLayout = () => {
  const location = useLocation();
  const { userLoading, queryUserInfo, member } = useStore('user');
  const { queryCommonConfig } = useStore('systemConfig');
  const { orgId } = useOrg();
  const isVisualTrackingPreview = resolveVisualTrackingPreviewMode({
    search: location.search,
    isFramed: isCurrentWindowFramed(),
    storage: typeof window === 'undefined' ? null : window.sessionStorage,
  });

  useVisualTrackingLayoutInit({
    isVisualTrackingPreview,
    orgId: orgId || '',
    accountId: member?.memberId,
    clientType: TrackingClientType.Mobile,
  });

  useEffect(() => {
    if (checkLogin()) {
      queryUserInfo();
      queryCommonConfig();
    } else if (location.pathname.replace(/\//g, '') !== 'login') {
      redirectToLogin();
    }
  }, []);

  return (
    <div className={'ehr-mobile'}>
      {userLoading ? (
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loading type="dot" />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
};

export default observer(MobileLayout);
